import { Component, OnInit} from '@angular/core';
import { FormGroup,  FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {AuthService}from '../../../../../auth-guard/auth.service';

@Component({
  selector: 'editprofile',
  templateUrl: './editprofile.html',
})

export class Editprofile implements OnInit  {

    editregform: FormGroup;
    userdtls:any;
    shipingarr:any=[];
    paramdata:any;

  constructor(private fb: FormBuilder, private router: Router,private authservice:AuthService,public dialog: MatDialog) {

    this.intform();
    this.getshiping();
  
  }

  intform(){
    this.userdtls = this.authservice.getstoragedtl();
    this.editregform = this.fb.group({
        fl_name     : this.userdtls.first_name,
        last_name   : this.userdtls.last_name,
        email       : this.userdtls.user_id,
        scac_name   : this.userdtls.customer_id,
        pool_name   : 'FCCP',
    shippingline    : []
    });
    this.editregform.get('email').disable();
    this.editregform.get('scac_name').disable();
    this.editregform.get('pool_name').disable();   
  }

  ngOnInit() {
  
  }
 
  saveprofile()
  {
    var paramdata={
      user_email:this.editregform.get('email').value,
      first_name : this.editregform.get('fl_name').value ,
      last_name: this.editregform.get('last_name').value ,
      creater_id:this.editregform.get('email').value,
      user_scac: this.editregform.get('scac_name').value,
      poolcode :this.editregform.get('pool_name').value,
      shippingline :(this.editregform.get('shippingline').value).toString(),
    };
    this.authservice.showloader(true);
    this.authservice.selectdata('fccpupdateuserdetails', paramdata).subscribe((resp:any) =>
    { 
      this.authservice.showloader(false);  
      if(resp.length > 0)
      { 
        this.authservice.showToast_closeable('top-center','Updated..Please reload the page for apply changes',8000,true,'S') ; 
        this.authservice.resetstoragevalues('first_name',this.editregform.get('fl_name').value);
        this.authservice.resetstoragevalues('last_name',this.editregform.get('last_name').value);
        this.authservice.resetstoragevalues('shippingline',(this.editregform.get('shippingline').value).toString());
        window.sessionStorage.setItem('username',this.editregform.get('fl_name').value);
        this.dialog.closeAll();
      }
      else{
        this.authservice.showToast_closeable('top-center','Not Updated.Contact customer service',8000,true,'E') ;
      }
      
    },
    onerror => 
    {
        this.authservice.showloader(false);
        this.authservice.showToast_closeable('top-center','Not Updated.Contact customer service',8000,true,'E') ;
        console.log("Error man"); 
    });
  }



getshiping()
{
      this.paramdata={};
      this.paramdata.category='FCCPSSL'; 

      this.authservice.selectdata('getreferencecodes', this.paramdata).subscribe((getData:any) =>
      { 
        console.log(getData);
        this.shipingarr=getData
        this.editregform.get('shippingline').setValue((this.userdtls.shippingline).split(','));
      },
      onerror => 
      {
      console.log("Error man"); 
      });

 }



}